var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/down",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9355675,4.00612154 C15.208329,3.69439407 15.682151,3.66280594 15.9938785,3.93556748 C16.2772671,4.18353251 16.3291356,4.59766319 16.1312944,4.90511584 L16.0644325,4.99387846 L9.496,12.5 L16.0644325,20.0061215 C16.3123976,20.2895102 16.3088339,20.7068612 16.0719312,20.9853309 L15.9938785,21.0644325 C15.7104898,21.3123976 15.2931388,21.3088339 15.0146691,21.0719312 L14.9355675,20.9938785 L7.93556748,12.9938785 C7.7128865,12.7393859 7.69061841,12.3719401 7.86876319,12.0948569 L7.93556748,12.0061215 L14.9355675,4.00612154 Z",
    id: "Stroke-3-Copy",
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "translate(12.000005, 12.500000) scale(-1, -1) rotate(90.000000) translate(-12.000005, -12.500000) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.f1e56cc5.svg";
export { ForwardRef as ReactComponent };